import { MortgageeType } from '@models/lender';
import { RadioGroupItem } from '../../atomic/atoms/radio-group/radio-group.component';

export const computerShareInstitutionId = 'qnMR3Wv';

export const MortgageTypeOptions: RadioGroupItem<MortgageeType>[] = [
	{ label: 'Financial institution', value: MortgageeType.INSTITUTION },
	{ label: 'Computershare', value: MortgageeType.COMPUTERSHARE },
	{ label: 'Private lender', value: MortgageeType.PRIVATE_LENDER },
];
